import React, { useState, useEffect } from "react";
import HeaderNavigation from "../components/chat/header-navigation";

import ChatUserList from "../components/chat/chat-user-list";
import ChatHistoryHeader from "../components/chat/chat-history-header";
import ChatHistorybody from "../components/chat/chat-history-body";
import ChatHistoryFooter from "../components/chat/chat-history-footer";
import { userService } from "../services/userService";
import { useDispatch, useSelector } from "react-redux";
import { chatServiceApi } from "../services/chatServiceApi";
import ChatService from "../services/ChatService";
import "../components/chat/chat-style.css";

import { logout } from "../redux/slices/authSlice";
import Layout from "../components/layout/layout";
import { fetchUserInfo } from "../redux/slices/userSlice";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
const ChatPage = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { userInfo } = useSelector((state) => state.user);

  const [userList, setUserReceiveList] = useState([]);

  const [selectedChatRoom, setSelectedChatRoom] = useState(null);

  const [userChatWith, setUserChatWith] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  var userId = 0;
  if (user) {
    const decoded = jwtDecode(user);
    userId = decoded["sub"];
  } else {
    userId = 0;
  }
  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        try {
          const decoded = jwtDecode(user);
          const userId = decoded["sub"];
          await dispatch(fetchUserInfo(userId)).unwrap();
        } catch (err) {
          dispatch(logout());
          toast.error(err.message || "Tài khoản đã bị khóa!");
        }
      }
    };

    fetchData(); // Gọi hàm async bên trong useEffect
  }, [dispatch, user]);

  useEffect(() => {
    try {
      console.log(userInfo, "userInfo");
      async function fetchDataStaff() {
        const response = await userService.getUsersByRole("Staff");
        setUserReceiveList(response.data);
      }

      async function fetchDataHistoryUsers() {
        const response = await chatServiceApi.getChatHistoryForStaff(
          userInfo.id
        );
        setUserReceiveList(response);
      }

      if (userInfo.checkStaff) {
        fetchDataHistoryUsers();
      } else {
        fetchDataStaff();
      }
    } catch (error) {
      console.log(error, "error");
    }
    ChatService.initSignalR();
  }, [dispatch, user, userInfo]);

  const filteredRooms = userList.filter((user) =>
    user.fullName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectChatRoom = async (staffId) => {
    console.log(staffId, "handleSelectChatRoom");
    try {
      if (userInfo.checkStaff) {
        const response = await chatServiceApi.selectedChatRoom(
          staffId,
          userInfo.id
        );

        setSelectedChatRoom(response.id);
        return;
      }
      const response = await chatServiceApi.selectedChatRoom(
        userInfo.id,
        staffId
      );

      setSelectedChatRoom(response.id);
    } catch (error) {
      console.error(" Error creating chat room", error);
    }
  };
  useEffect(() => {}, [selectedChatRoom]);
  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="customer-chat">
            <HeaderNavigation />
            <div className="row chat-window">
              <ChatUserList
                userList={filteredRooms}
                handleSelectChatRoom={handleSelectChatRoom}
                setUserChatWith={setUserChatWith}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />

              <div className="col-lg-8 chat-cont-right chat-window-long">
                <div className="card chat-window mb-0 shadow-none flex-fill">
                  {userChatWith && (
                    <>
                      <ChatHistoryHeader userChatWith={userChatWith} />
                      <ChatHistorybody
                        chatRoomId={selectedChatRoom}
                        userChatWith={userChatWith}
                        userInfo={userInfo}
                      />
                      <ChatHistoryFooter
                        chatRoomId={selectedChatRoom}
                        userInfo={userInfo}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ChatPage;
